import React from 'react';
import { Sidebar } from './Sidebar';
import { Header } from '../../App';
import { useSidebar } from '../../contexts/SidebarContext';
import MobileFooterNav from './MobileFooterNav';

interface MainLayoutProps {
  children: React.ReactNode;
  currentPage: string;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children, currentPage }) => {
  const { isSidebarOpen } = useSidebar();

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-900">
      <Sidebar currentPage={currentPage} />
      <div 
        className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 ease-in-out ${
          isSidebarOpen ? 'sm:ml-64' : 'sm:ml-0'
        }`}
      >
        <Header currentPage={currentPage} />
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50 dark:bg-gray-900 pb-16 sm:pb-0">
          {children}
        </main>
        <MobileFooterNav />
      </div>
    </div>
  );
}; 